var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLockIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 28,
    viewBox: "0 0 25 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 17.5605V20.3383M5.3125 11.3505C5.99017 11.3105 6.8256 11.3105 7.9 11.3105H17.1C18.1744 11.3105 19.0099 11.3105 19.6875 11.3505M5.3125 11.3505C4.46679 11.4003 3.86679 11.5126 3.35467 11.7646C2.54321 12.1641 1.88349 12.8015 1.47003 13.5855C1 14.4769 1 15.6435 1 17.9771V19.9216C1 22.2552 1 23.4219 1.47003 24.3133C1.88349 25.0973 2.54321 25.7346 3.35467 26.1341C4.27716 26.5883 5.48477 26.5883 7.9 26.5883H17.1C19.5153 26.5883 20.7228 26.5883 21.6454 26.1341C22.4568 25.7346 23.1165 25.0973 23.5299 24.3133C24 23.4219 24 22.2552 24 19.9216V17.9771C24 15.6435 24 14.4769 23.5299 13.5855C23.1165 12.8015 22.4568 12.1641 21.6454 11.7646C21.1332 11.5126 20.5332 11.4003 19.6875 11.3505M5.3125 11.3505V8.5327C5.3125 4.6974 8.53046 1.58826 12.5 1.58826C16.4695 1.58826 19.6875 4.6974 19.6875 8.5327V11.3505",
    stroke: "url(#paint0_linear_1_834)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_834",
    x1: 1,
    y1: 14.0883,
    x2: 24,
    y2: 14.0883,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#02AAB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00CDAC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockIcon);
export default __webpack_public_path__ + "static/media/LockIcon.5d02c3a5027ee3b4e37a3e79f1ff2d38.svg";
export { ForwardRef as ReactComponent };